import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./monday-host-theme.css";
import { Provider } from "react-redux";
import { store } from "./redux/store.ts";

// Strip ALL query parameters from the visible URL on boot so nothing (e.g. the
// Monday session token) leaks via browser history or the Referer header.
(() => {
  try {
    const url = new URL(window.location.href);
    if (url.search) {
      url.search = "";
      window.history.replaceState({}, document.title, url.toString());
    }
  } catch {
    // Ignore malformed URLs; nothing to clean up.
  }
})();

// import { getRecipients } from "./redux/reducers/messengerSlice";
// import { fetchLabels } from "./redux/reducers/authSlice";











// Listen for auth token messages from parent window (for embedded usage)
window.addEventListener('message', (event) => {
  // Verify origin for security
  const allowedOrigins = [
    'https://your-main-app-domain.com', // Replace with your actual domain
    'http://localhost:3000', // For development
    'http://localhost:5173', // Vite dev server default port
    'https://console.notifyer-systems.com' // Based on the console URL in your app
  ];
  
  if (!allowedOrigins.includes(event.origin)) {
    return;
  }
  
  if (event.data.type === 'SET_AUTH_TOKEN') {

    // The authToken from URL parameters will be used automatically by getAuthToken() utility
    // No need to do anything special here
  }
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
